import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {PhysicalTemplate} from '../message/PhysicalTemplate';
import {PhysicalTemplateCriteria} from './PhysicalTemplateCriteria';

export class PhysicalTemplateWrapper extends BaseWrapper<PhysicalTemplate, PhysicalTemplateCriteria, BasicScenario>  {}

